<template>
  <div class="">
    <TitleWithBackButton
      title="Magazzino"
      back-route="Homepage"
      icon="mdi-warehouse"
    ></TitleWithBackButton>
    <WarehouseHome
       :style="{
        'pointer-events': canManageWarehouse ? 'all' : 'none',
        opacity: canManageWarehouse ? '1' : '0.2',
      }"
    ></WarehouseHome>
    <ErrorDialogComponent
      v-if="showErrorDialog"
      :open-dialog="showErrorDialog"
      title="Utente non abilitato"
      :error-message="errorMessage"
      @close-error="goBack"
    >
    </ErrorDialogComponent>
  </div>
</template>

<script>
import WarehouseHome from "@/components/areas/warehouse/WarehouseHome.vue";
import TitleWithBackButton from "@/components/common/TitleWithBackButton.vue";
import ErrorDialogComponent from "@/components/common/errorComponent/ErrorDialogComponent.vue";

export default {
  components: {
    WarehouseHome,
    TitleWithBackButton,
    ErrorDialogComponent,
  },
  data: function () {
    return {
      showErrorDialog: false,
      errorMessage: "",
      warehousePermission: [],
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Homepage" });
    },
  },
  computed: {
    canManageWarehouse() {
      if (
        this.warehousePermission.includes("view")
      )
        return true;
      else {
        this.showErrorDialog = true;
        this.errorMessage = "Accesso al magazzino non autorizzato ";
        return false;
      }
    },
  },
  permissions: {
    Warehouse: {
      bind: "warehousePermission",
    },
  },
};
</script>

<style>
</style>